import React from 'react';
import { mergeStyles } from '@cian/utils';

import { EPropertyGuidesGroups } from '../../utils/ab_mainpage_property_guides';
import { useMediaQuery } from './utils/useMediaQuery';
import { SimplifiedCards } from './SimplifiedCards';
import { GlamorousCards } from './GlamorousCards';

import { EPageKind } from '../../types/page';
import styles from './PropertyGuides.css';

interface IProps {
  pageKind: EPageKind;
  experiment: EPropertyGuidesGroups;
}

export const PropertyGuides = ({ pageKind, experiment }: IProps) => {
  const { className: rootClassName } = mergeStyles('cg-container-fluid-xs', styles['container']);
  const device = useMediaQuery();

  return (
    <div className={rootClassName}>
      <h2 className={styles['title']}>Полезные сервисы ЦИАН</h2>
      {experiment === EPropertyGuidesGroups.Simple && <SimplifiedCards pageKind={pageKind} device={device} />}
      {experiment === EPropertyGuidesGroups.Glamour && <GlamorousCards pageKind={pageKind} device={device} />}
    </div>
  );
};
